import { FC, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const idObj: any = {
    us: '#dp3-teaser-B',
    jp: '#dp3-SubscribeA',
};
const TheComp: FC = () => {
    const { locale = 'us' } = useRouter();
    const idHref = idObj[locale] || idObj['us'];
    const { t } = useLang('dp3.teaser.EnergySolutions');
    const [listA, setListA] = useState(
        locale === 'jp'
            ? [
                  {
                      pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717747225431/sl_DP3%20(1).png',
                      title: t('item1_desc'),
                      desc: t('item1_title'),
                      price1: t('common_price'),
                      price2: t('common_price'),
                      btnText1: t('btn_text'),
                  },
                  {
                      pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717747161881/DELTA%20Pro%203%20%2B%20EB-2.png',
                      title: t('item2_desc'),
                      desc: t('item2_title'),
                      moreText: t('item2_more_btn'),
                      price1: t('common_price'),
                      price2: t('common_price'),
                      btnText1: t('btn_text'),
                  },
                  {
                      pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717752246784/DP3%2BSHP2%20(1).png',
                      title: t('item3_desc'),
                      desc: t('item3_title'),
                      price1: t('common_price'),
                      price2: t('common_price'),
                      moreText: t('item3_btn'),
                      moreLink: '',
                      btnText1: t('btn_text'),
                  },
              ]
            : [
                  {
                      pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717226272917/dp3_eb2.png',
                      title: t('item1_desc'),
                      desc: t('item1_title'),
                      price1: t('common_price'),
                      price2: t('common_price'),
                      btnText1: t('btn_text'),
                  },
                  {
                      pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717226273087/dp3_shp2.png',
                      title: t('item3_desc'),
                      desc: t('item3_title'),
                      price1: t('common_price'),
                      price2: t('common_price'),
                      moreText: t('item3_btn'),
                      moreLink: '',
                      btnText1: t('btn_text'),
                  },
                  {
                      pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717226272738/dp3_ac_sga.png',
                      title: t('item2_desc'),
                      desc: t('item2_title'),
                      moreText: t('item2_more_btn'),
                      price1: t('common_price'),
                      price2: t('common_price'),
                      btnText1: t('btn_text'),
                  },
              ],
    );

    return (
        <div id="dp3-teaser-J" className={`${css.thecomp} dp3-module-box dp3-teaser-J`}>
            <h2 className="dp3-title left">{t('title')}</h2>
            <div className="dp3-inter EnergySolutions-list">
                {listA.map((item: any, index: number) => {
                    return (
                        <div key={index} className="EnergySolutions-item">
                            <div className="EnergySolutions-img">
                                <EditorImg pc={item.pc} />
                            </div>
                            <div className="EnergySolutions-title">{item.title}</div>
                            <div className="EnergySolutions-desc">{item.desc}</div>
                            <div className="EnergySolutions-links">
                                {item.moreText && (
                                    <div className={`EnergySolutions-tips-btn EnergySolutions-tips-${locale === 'jp' ? 'jp' : 'other'}`}>{item.moreText}</div>
                                )}
                            </div>
                            <div className="EnergySolutions-prices">
                                <span className="EnergySolutions-price1">{item.price1}</span>
                            </div>
                            <a href={idHref} className="dp3-btn EnergySolutions-item-btn">
                                {t('btn_text')}
                            </a>
                            <div className="EnergySolutions-item-tips">
                                {t.rich('tips_line', {
                                    text: (text: any) => <span className="num">{text}</span>,
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="dp3-inter EnergySolutions-btn-line">
                <a
                    href={idHref}
                    className="dp3-btn EnergySolutions-buy-btn"
                    onClick={() => {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_signup',
                            button_name: t('btn_text'),
                        });
                    }}
                >
                    {t('btn_text')}
                </a>
            </div>
            <div className="EnergySolutions-tips-line">
                {t.rich('tips_line', {
                    text: (text: any) => <span className="num">{text}</span>,
                })}
            </div>
        </div>
    );
};

export default TheComp;
